<template>
  <v-sheet
    class="d-flex align-center justify-center pa-6"
    color="surface"
    min-height="100vh">
    <v-card border class="not-found-card" max-width="520" rounded="xl">
      <v-card-text class="pa-8 text-center">
        <v-sheet
          class="d-inline-flex align-center justify-center mb-5"
          color="light-blue"
          height="72"
          rounded="xl"
          width="72">
          <v-icon color="secondary" icon="mdi-alert-circle-outline" size="40">
          </v-icon>
        </v-sheet>

        <div class="text-h2 font-weight-bold text-primary mb-2">404</div>
        <div class="text-h6 font-weight-bold mb-2">Сторінку не знайдено</div>
        <div class="text-body-2 text-medium-emphasis">
          Вибачте, але сторінки, яку ви шукаєте, не існує
        </div>

      <v-btn
          class="mt-6"
          color="primary"
          prepend-icon="mdi-home-outline"
          @click="$router.push({ name: 'home' })">
          На головну
        </v-btn>
      </v-card-text>
    </v-card>
  </v-sheet>
</template>

<style scoped>
.not-found-card {
  width: 100%;
}
</style>
